-<template>
    <div>
        <div class="d-md-flex mb-3">
            <div class="col-md-6 col-sm-12 col-xs-12 p-0 p-md-3">
                <b-card title="Dirección y Teléfono">
                    <b-card-text class="pt-3 pl-3">
                        <p><b>Dirección:</b> {{ base.direccion }}</p>
                        <p><b>Teléfono:</b> {{ base.telefono }}</p>
                        <p><b>País:</b> {{ base.pais_de_nacimiento }}</p>
                    </b-card-text>
                </b-card>
                <b-card title="Documentos subidos:">
                    <b-card-text>
                        <DocumentosSubidosComponent :title="false" :estilo="false" @actualizado="$emit('getBase')" :data="base" :url="url" :params="params" :ruta="'back.bases.borrar-documento'" @editarDocumento="editarDocumento"></DocumentosSubidosComponent>
                    </b-card-text>
                </b-card>
            </div>
            <div class="col-md-6 col-sm-12 col-xs-12 p-0">
                <DatosResponsables :base="base"></DatosResponsables>
                <b-card>
                    <Observaciones :observaciones="base.observaciones_club" @actualizar="editarObservacion" />
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
import DatosResponsables from '@/components/backend/bases/components/DatosResponsables';
import Observaciones from '@/components/backend/components/Observaciones.vue';
import DocumentosSubidosComponent from '@/components/backend/components/documentos/DocumentosSubidosComponent';

export default {
    props: ['base', 'url', 'params'],
    data() {
        return {
            parametros: {
                base_id: this.$route.params.base_id
            },
        }
    },
    methods: {
        editarObservacion(observacion) {
            this.base.filters = {};
            this.base.lista_id = this.lista_id;
            this.base.base_id = this.parametros.base_id;
            this.base.observaciones_club = observacion;

            this.$store.dispatch(this.config.getVuexAlias('back.bases.update'), this.base).then(re => {
                this.$toast.success('Observación editada correctamente.');
                this.$emit('getBase');
            }).catch(e => {
                this.$toast.error('Ha ocurrido un error.');
            });
        },
        editarDocumento(documento) {
            this.base.filters = {};
            this.base.lista_id = this.lista_id;
            this.base.base_id = this.parametros.base_id;
            this.base.documento_id = documento['id'];
            this.base.documento = documento;

            this.$store.dispatch(this.config.getVuexAlias('back.bases.editar-documento'), this.base).then(re => {
                this.$toast.success('Documento editado correctamente.');
                this.$emit('getBase');
            }).catch(e => {
                this.$toast.error('Ha ocurrido un error.');
            });
        }
    },
    computed: {
        lista_id() {
            return this.$route.params.lista_id;
        }
    },
    components: {
        DatosResponsables, Observaciones, DocumentosSubidosComponent
    }
}
</script>